import React, { useEffect, useRef, useState } from "react";
import { View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { Text } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { FlatList } from "react-native";
import { Image } from "react-native";
import { AppImages } from "../../utility/AppImages";
import Skeletons from "../skeleton-components/Skeletons";
import { LinearGradient } from "expo-linear-gradient";

const StreamChatListingComponent = ({ styles, showLoader, eventData }) => {
  const [streamChatData, setStreamChatData] = useState(eventData?.chats || []);

  const deviceSize = useDeviceSize();
  const flatListRef = useRef(null);

  useEffect(() => {
    const scrollToBottom = () => {
      if (flatListRef.current) {
        setTimeout(() => {
          flatListRef.current.scrollToIndex({
            animated: true,
            index: streamChatData.length - 1,
          });
        }, 100);
      }
    };

    scrollToBottom();
    setStreamChatData(eventData?.chats);
  }, [streamChatData, eventData]);

  return (
    <View
      style={{
        width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 290 : "100%",
      }}
    >
      {showLoader ? (
        <Skeletons
          height={533}
          width={"100%"}
          style={{
            borderRadius: 8,
            marginTop: deviceSize == DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 20,
            marginBottom: 20,
          }}
        />
      ) : (
        <LinearGradient
          colors={["rgba(31, 41, 55, 0.5)", "rgba(17, 24, 39, 0.5)"]}
          start={[0, 0]}
          end={[1, 1]}
          style={{
            width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 290 : "100%",
            height: 533,
            padding: 12,
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 18,
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: "#374151",
            marginTop: deviceSize == DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 20,
            marginBottom: 20,
          }}
        >
          {/* {deviceSize == DEVICE_SIZES.XS ||
              deviceSize == DEVICE_SIZES.SM ? (
                ""
              ) : ( */}
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XL
                ? AppFontStyle.BOLD_ANYBODY_18
                : AppFontStyle.BOLD_ANYBODY_14,
              { marginVertical: 10 },
            ]}
          >
            Stream Chat
          </Text>
          {/* // </View> */}
          {/* )} */}
          {streamChatData?.length === 0 ? (
            <View
              style={{
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? AppFontStyle.REGULAR_ANYBODY_16
                    : AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    textAlign: "center",
                    marginVertical: 20,
                    color: AppColors.gray_A3A3A3,
                  },
                ]}
              >
                No chats for this event
              </Text>
            </View>
          ) : (
            <FlatList
              showsHorizontalScrollIndicator={false}
              ref={flatListRef}
              style={{
                height:
                  deviceSize == DEVICE_SIZES.XS || deviceSize == DEVICE_SIZES.SM
                    ? 300
                    : 600,
              }}
              data={streamChatData}
              renderItem={({ item }) => (
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 8,
                    columnGap: 10,
                  }}
                >
                  <Image
                    source={item.profilePicture ?? AppImages.GiftImg}
                    style={{
                      width: 27,
                      height: 27,
                      borderRadius: 100,
                    }}
                  />
                  <View style={{ flex: 1, flexDirection: "row", columnGap: 5 }}>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? AppFontStyle.REGULAR_ANYBODY_16
                          : AppFontStyle.REGULAR_ANYBODY_14,
                      ]}
                    >
                      {item.userId}:
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { opacity: 0.5, lineHeight: 17 },
                      ]}
                    >
                      {item.commentData}
                    </Text>
                  </View>
                  <Image
                    source={item.gift}
                    style={{
                      width: 31,
                      height: 30,
                      borderRadius: 100,
                    }}
                  />
                </View>
              )}
            />
          )}
        </LinearGradient>
      )}
    </View>
  );
};

export default StreamChatListingComponent;
